module.exports = __webpack_public_path__ + "static/media/report_feedback_girl.0171ac78.png";